module.exports = __webpack_public_path__ + "1f2b1f6c553f16e1d5b903cc52c18300.svg";